import { createContext, useContext, useState, useEffect } from "react";
import appConstants from "../constants/appConstants";
import { useNavigate } from "react-router-dom";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const navigate = useNavigate();
  const [institute, setInstitute] = useState(null);
  const [user, setUser] = useState(null);

  const fetchInstituteData = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      //navigate("/login");
      return;
    };

    try {
      const response = await fetch(`${appConstants.API_ROOT_URL}get-my-institute`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        setInstitute(data.data);
      }
      else{
        if(data.message === "Expired token" || data.message === "Invalid or expired token"){
          localStorage.removeItem("authToken");
          localStorage.removeItem("userData");
          navigate("/login");
        }
      }
    } catch (error) {
      console.error("Failed to fetch institute data:", error);
    }
  };

  useEffect(() => {
    fetchInstituteData();
  }, []);

  return (
    <AppContext.Provider value={{ institute, setInstitute, user, setUser, fetchInstituteData }}>
      {children}
    </AppContext.Provider>
  );
  
};

export const useAppContext = () => useContext(AppContext);
